import { useAtomValue } from "jotai";
import { useMemo } from "react";

import { useFetchUserTypes } from "~/lib/hooks";
import { rosettaAtom } from "~/lib/rosetta";

export const useMostLikelyToSubscribe = () => {
  const { userTypes } = useFetchUserTypes();
  const asyncRosettaState = useAtomValue(rosettaAtom);
  const pianoIsLikelyToSubscribe =
    asyncRosettaState?.result?.instance?.rulesEngine.getFact("isLikelyToSubscribe") ?? false;

  const isMostLikelyToSubscribeUser = useMemo(
    () => userTypes.map(element => element.id).includes("018") || pianoIsLikelyToSubscribe,
    [pianoIsLikelyToSubscribe, userTypes],
  );

  return {
    isMostLikelyToSubscribeUser,
  };
};
